import { defineMessages } from 'react-intl';

export default defineMessages({
  DEFAULT_PRESENTER_FULLNAME: {
    defaultMessage: "L'équipe Didaskill",
  },

  REPLAY_TAG: {
    defaultMessage: 'Replay',
  },

  EDIT_LEARNING_RESOURCE: {
    defaultMessage: 'Mettre à jour la ressource',
  },

  DELETE_LEARNING_RESOURCE: {
    defaultMessage: 'Supprimer la ressource',
  },

  REFERENCED_LESSONS: {
    defaultMessage: 'Cours ({count})',
  },

  REFERENCED_COURSES: {
    defaultMessage: 'Formations ({count})',
  },

  LIKES_COUNT: {
    defaultMessage: '{count, plural, one {# like} other {# likes}}',
  },

  DISLIKES_COUNT: {
    defaultMessage: '{count, plural, one {# dislike} other {# dislikes}}',
  },

  OPEN_ENGAGEMENT: {
    defaultMessage: 'Voir les avis ({count})',
  },
});
